
 
  document.addEventListener("DOMContentLoaded", function () {
    // Use MutationObserver to ensure dynamically loaded elements are handled
    const observer = new MutationObserver(function () {
      // Select the span elements containing "Checkout"
      var spanElements = document.querySelectorAll(
        '#MULTIVARIANTS_APP_SECTION_PLACE > #multivariants_setbox_footer > #multivariants_add_to_cart_button_h > #multivariants_add_to_checkout_button > span'
      );

      if (spanElements.length > 0) {
        spanElements.forEach(function (span) {

          if (span.textContent.trim() === "Checkout") {

            var sourceElements = document.querySelectorAll(".shopify-product-form");

            var targetElement = document.querySelector(
              "#MULTIVARIANTS_APP_SECTION_PLACE > #multivariants_setbox_footer > #multivariants_add_to_cart_button_h"
            );
            console.log("Target element:", targetElement);
            if (sourceElements.length > 0 && targetElement) {
              sourceElements.forEach(function (sourceElement) {
                sourceElement.classList.add("new-checkout-verita");
                // Append the source element to the target element
                targetElement.appendChild(sourceElement);
                
              });

            } else {
             
            }
          }
        });

        // Disconnect the observer after processing
        observer.disconnect();
        
      } else {
      }
    });

    // Start observing the document for changes
    observer.observe(document.body, { childList: true, subtree: true });
  }); 







// //-- Product Card wishlist Button Js append to add to cart section --
//   // Select all span elements within the specified container
// //   setTimeout(function () {
// //     // Locate <span> elements with "Checkout" text
// //     var spanElements = document.querySelectorAll(
// //       '#MULTIVARIANTS_APP_SECTION_PLACE > #multivariants_setbox_footer > #multivariants_add_to_cart_button_h > #multivariants_add_to_checkout_button > span'
// //     );
  
// //     spanElements.forEach(function (span) {
// //       if (span.textContent.trim() === 'Checkout') {
// //         // Locate source elements
// //         var sourceElements = document.querySelectorAll('.shopify-product-form');
  
// //         if (sourceElements.length === 0) {
// //           console.warn('No .shopify-product-form elements found.');
// //           return;
// //         }
  
// //         // Add new class and prepare for appending
// //         sourceElements.forEach(function (sourceElement) {
// //           sourceElement.classList.add('new-checkout-verita'); // Add the new class
// //         });
  
// //         // Locate the target element
// //         var targetElement = document.querySelector(
// //           '#MULTIVARIANTS_APP_SECTION_PLACE > #multivariants_setbox_footer > #multivariants_add_to_cart_button_h'
// //         );
  
// //         if (!targetElement) {
// //           console.error('Target element not found. Aborting operation.');
// //           return;
// //         }
  
// //         // Append each source element to the target
// //         sourceElements.forEach(function (sourceElement) {
// //           const clonedElement = sourceElement.cloneNode(true); // Clone instead of moving
// //           targetElement.appendChild(clonedElement); // Append the cloned element
// //         });
  
// //         console.log('Elements successfully appended to the target.');
// //       }
// //     });
// //   }, 1000); // Adjust the delay time as needed (1 seconds here)
  
// const sourceElement = document.getElementById('product-form-main-8181197340869-template--18296165892293__main');

//   // Select the destination container by ID
// const destinationContainer = document.querySelectorAll('#MULTIVARIANTS_APP_SECTION_PLACE #multivariants_add_to_cart_button_h');

// // Append the source element to the destination container
// destinationContainer.appendChild(sourceElement);

// // Add a class to the source element after appending
// sourceElement.classList.add('new-class');
